<div
  [ngClass]="{
    disable: !active,
    'toggle-small': size === 'small',
    'toggle-middle': size === 'middle',
    'toggle-big': size === 'big',
    'color_green': color.color === 'green',
    'color_scarlet': color.color === 'scarlet',
    'color_dark-sky-blue': color.color === 'blue',
    'color_brown-grey': color.color === 'grey',
    'color_violet': color.color === 'violet',
    'color_disable_inactive': color.disableDefault
  }"
  (click)="toggle()"
>
  <div class="oval"></div>
</div>
